function AgentCardView() {
    "use strict";

    this.UserId = -1;
    this.AgentIds = [];
    this.AgentsByOrganization = {};
    this.FullName = '';
    this.UserName = '';
    this.FirstName = '';
    this.LastName = '';
    this.OrganizationIds = [];
    this.Role = null;
    // Data
    this.User = null;
    this.SortId = '';
    this.SecondSortId = '';

}
if (typeof exports !== 'undefined') {
    module.exports = AgentCardView;
}